const platform = require('platform');

/**
 * CSS取得
 */
export function getStyle(elem, prop) {
	const style = document.defaultView.getComputedStyle(elem, null);
	return style.getPropertyValue(prop);
}

/**
 * イベントトリガー
 */
export function trigger(elem, event, detail = {}) {
	let ev;

	if (platform.name !== 'IE') {
		ev = new CustomEvent(event, { detail: detail });
	} else {
		ev = document.createEvent('CustomEvent');
		ev.initCustomEvent(event, true, true, detail);
	}

	elem.dispatchEvent(ev);
}

/**
 * オフセット
 */
export function offset(elem, pos) {
	const rect = elem.getBoundingClientRect();

	if (pos === 'top') {
		const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
		return rect.top + scroll_top;
	} else if (pos === 'left') {
		const scroll_left = window.pageXOffset || document.documentElement.scrollLeft;
		return rect.left + scroll_left;
	}
}



// WEBPACK FOOTER //
// ./src/js/module/utility.js